import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import CatalogPage from "./pages/CatalogPage";
import ProductPage from "./pages/ProductPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import OrderSuccessPage from "./pages/OrderSuccessPage";
import QuickOrderPage from "./pages/QuickOrderPage";
import QuotePage from "./pages/QuotePage";
import AuthPage from "./pages/AuthPage";
import AccountPage from "./pages/AccountPage";
import BlogPage, { BlogPostPage } from "./pages/BlogPage";
import AboutPage, { ContactsPage } from "./pages/AboutPage";
import OrderTrackingPage from "./pages/OrderTrackingPage";
import B2BPage from "./pages/B2BPage";

function AppRouter() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/katalogs" element={<CatalogPage />} />
          <Route path="/produkts/:slug" element={<ProductPage />} />
          <Route path="/grozs" element={<CartPage />} />
          <Route path="/noformesana" element={<CheckoutPage />} />
          <Route path="/pasutijums/:number" element={<OrderSuccessPage />} />
          <Route path="/atra-pasutisana" element={<QuickOrderPage />} />
          <Route path="/piedavajums" element={<QuotePage />} />
          <Route path="/pieteikties" element={<AuthPage />} />
          <Route path="/konts" element={<AccountPage />} />
          <Route path="/blogs" element={<BlogPage />} />
          <Route path="/blogs/:slug" element={<BlogPostPage />} />
          <Route path="/par-mums" element={<AboutPage />} />
          <Route path="/kontakti" element={<ContactsPage />} />
          <Route path="/pasutijuma-statuss" element={<OrderTrackingPage />} />
          <Route path="/b2b" element={<B2BPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <AppRouter />
            <Toaster position="top-right" richColors />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
